import { set } from "lodash";
import { useContext, useMemo } from "react";
import { Field } from "../../../../store/launch-configurations/models/internal/field";
import { ConfigContext } from "../config-context";
import { useHaveAsObject } from "./have-as-object.hook";

/**
 * This hook will take the list of fields and return the resolver for them
 * @param fields Array of fields
 * @returns resolver for form
 */
export function useFieldSchema(fields: Array<Field.Field<string>>) {
  const haveAsObject = useHaveAsObject();

  const { config } = useContext(ConfigContext);

  const reducedFields = useMemo(
    () => fields.reduce((acc, curr) => set(acc, curr.field, curr), {}),
    [fields]
  );

  return useMemo(() => haveAsObject(reducedFields, config), [
    reducedFields,
    haveAsObject,
    config,
  ]);
}
